import { Helmet } from 'react-helmet';

import { Card } from 'antd';

export const PagePurchase = () => {
  return (
    <>
      <Helmet>
        <title>구매 완료</title>
      </Helmet>
      <div style={{maxWidth: '600px'}}>
        <Card title="상품을 구매했습니다." headStyle={{textAlign: 'left'}}>
          <h3>감사합니다.</h3>
        </Card>
      </div>
    </>
  )
}